import React, { Component } from 'react';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import asyncRoute from '../../../helpers/hoc/asyncRoute';
import Error from '../error';

const Tooltip = asyncRoute(() => import('../../../components/FormElements/ToolTip'));
const InfoButton = asyncRoute(()=> import('../../InfoButton'));

export default class index extends Component {
  render() {
    const { onChange, onKeyDown=()=>{}, onBlur, setting, submited, touched, error, value, disabled,indexForMultipleRender=-1, infoIcon = false, onInfoClick=()=>{} } = this.props;
    const { labelLayout = 'col-sm-6', isFormControl = true,isFileType=false,acceptType='',addBreakOptional=true, divLayout="",infoStyle, showOptional = true } = setting;
    return (
      <div className={`form-group row ${divLayout}`}>
        {setting.label && <label htmlFor={`${setting.key}${indexForMultipleRender >=0 ? indexForMultipleRender :''}`} className={`${labelLayout} col-form-label`}>{setting.label}{(setting.indexWithLabel && indexForMultipleRender != 0) ? ` ${indexForMultipleRender + 1}` : ''}{" "}{(setting.required) ? <span className='text-danger'>*</span> : showOptional && <>
        {
          !setting.required && addBreakOptional &&
           <InfoButton 
           infoIcon={infoIcon}
           onInfoClick={onInfoClick}
           infoStyle={infoStyle}
           />
        }
        {addBreakOptional && <br />}{(setting.required == false) ?<span className="small" style={{ color: "#1925238a" }}>Optional</span> : ''}</>}
        {
          (setting.required || !addBreakOptional) &&
           <InfoButton 
           infoIcon={infoIcon}
           onInfoClick={onInfoClick}
           infoStyle={infoStyle}
           />
        }
        </label>}
        <div className={setting.displayLayout}>
          <input
            id={`${setting.key}${indexForMultipleRender >= 0 ? indexForMultipleRender : ''}`}
            className={isEmpty(error) ? isFormControl && "form-control" : `${isFormControl && 'form-control'} has-error`}
            onChange={onChange}
            onKeyDown={onKeyDown}
            onBlur={onBlur}
            type={setting.type}
            name={setting.key}
            min={setting.min}
            max={setting.max}
            value={value}
            placeholder={setting.placeholder}
            disabled={disabled}
            accept={isFileType ? acceptType : ''}
            step={setting.step || 1}
            {...(setting.type == 'checkbox' && { checked: value })}
          />
          {(submited || touched) && (<Error setting={setting} error={error} />)}
        </div>
        {setting.tooltip && <Tooltip text={setting.tooltip} />}
      </div>
    );
  }
}

// ----* input propTypes set *----
index.propTypes = {
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,

  // -----* setting PropTypes *----
  setting: PropTypes.shape({
    required: PropTypes.bool,
    label: PropTypes.string,
    key: PropTypes.string,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    tooltip: PropTypes.string,
    touched: PropTypes.object
    // min: PropTypes.oneOfType([
    //   // PropTypes.string,
    //   PropTypes.number,
    //   PropTypes.instanceOf(['sdf'])
    // ]),
  }),
};
